import { render, staticRenderFns } from "./SimpleSwitch.vue?vue&type=template&id=7908da9a&scoped=true&"
import script from "./SimpleSwitch.vue?vue&type=script&lang=js&"
export * from "./SimpleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSwitch.vue?vue&type=style&index=0&id=7908da9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908da9a",
  null
  
)

export default component.exports